@let rocketState = state();
<div
  class="rocket-wrapper"
  [ngClass]="rocketState"
>
  <svg
    class="rocket-svg"
    viewBox="0 0 60 120"
    role="presentation"
  >
    <defs>
      <radialGradient
        id="rocket-flame-gradient"
        cx="50%"
        cy="35%"
        r="65%"
      >
        <stop
          offset="0%"
          stop-color="#fff7cc"
        />
        <stop
          offset="55%"
          stop-color="#ffd54f"
        />
        <stop
          offset="100%"
          stop-color="#ff8a00"
        />
      </radialGradient>
    </defs>
    <path
      class="rocket-body"
      d="M30 2
         C42 18 50 36 50 58
         V94
         H10
         V58
         C10 36 18 18 30 2Z"
    />
    <path
      class="rocket-nozzle"
      d="M22 94 H38 V104 H22 Z"
    />
    <path
      class="rocket-fin rocket-fin-left"
      d="M14 90 L6 108 L22 98 Z"
    />
    <path
      class="rocket-fin rocket-fin-right"
      d="M46 90 L54 108 L38 98 Z"
    />
    <circle
      class="rocket-flame"
      cx="30"
      cy="108"
      r="12"
    />
  </svg>
</div>
